import { lazy } from 'react';

export const routes = [
    {
        component: lazy(() => import('module/activity/ActivityExport')),
        permissions: [],
        path: '/activity-export',
    },
];
